export enum UserRole {
    Owner = 'OWNER',
    AccountManager = 'ACCOUNT_MANAGER',
    AccountManagerTrusted = 'ACCOUNT_MANAGER_TRUSTED',
    Merchant = 'MERCHANT',
    TeamLead = 'TEAM_LEAD',
    Trader = 'TRADER',
    Operator = 'OPERATOR'
}
